import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Injectable, Inject, PLATFORM_ID, Optional, ChangeDetectorRef, NgModule } from '@angular/core';
import { __decorate, __awaiter } from 'tslib';
import { FormControl, Validators, FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i1$1 from '@angular/router';
import { Router, ActivatedRoute, RouterModule } from '@angular/router';
import * as i2 from '@mtgame/core';
import { BaseModel, ToBackHook, ModelInstance, ConfigService, User, Store, validateEmail, markFormGroupTouched, handleError, ReferenceApi } from '@mtgame/core';
import { Locales, getTimezone, ToastService, DialogService, DialogRef, DialogConfig, LocalizationService, ButtonModule, TextFieldModule, DropdownModule, CheckboxModule, ToastModule, DialogModule, SvgIconModule, LocalizationModule } from '@mtgame/ui';
import * as i1 from '@angular/common/http';
import { HttpParams, HttpClient, HttpClientModule } from '@angular/common/http';
import { map, switchMap, take, tap } from 'rxjs/operators';
import * as Fingerprint2 from 'fingerprintjs2';
import * as UAParser from 'ua-parser-js';
import { isPlatformBrowser, CommonModule } from '@angular/common';
import { Observable, from } from 'rxjs';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/router';
import * as ɵngcc2 from '@mtgame/core';
import * as ɵngcc3 from '@angular/common/http';
import * as ɵngcc4 from '@angular/forms';
import * as ɵngcc5 from '@mtgame/ui';
import * as ɵngcc6 from '@angular/common';

function RegistrationComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementStart(2, "a", 6);
    ɵngcc0.ɵɵlistener("click", function RegistrationComponent_div_3_Template_a_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r3.openLoginModal()); });
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.localization.hint, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.localization.auth);
} }
function RegistrationComponent_form_4_mtg_dropdown_item_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mtg-dropdown-item", 20);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "mtgCityName");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r6 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("value", item_r6);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 2, item_r6));
} }
function RegistrationComponent_form_4_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "form", 7);
    ɵngcc0.ɵɵlistener("submit", function RegistrationComponent_form_4_Template_form_submit_0_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r7.submit()); });
    ɵngcc0.ɵɵelementStart(1, "div", 8);
    ɵngcc0.ɵɵelement(2, "mtg-text-field", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 8);
    ɵngcc0.ɵɵelement(4, "mtg-text-field", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 8);
    ɵngcc0.ɵɵelement(6, "mtg-text-field", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 8)(8, "mtg-dropdown", 12)(9, "mtg-dropdown-item");
    ɵngcc0.ɵɵtext(10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(11, RegistrationComponent_form_4_mtg_dropdown_item_11_Template, 3, 4, "mtg-dropdown-item", 13);
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(12, "div", 8);
    ɵngcc0.ɵɵelement(13, "mtg-text-field", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(14, "div", 15)(15, "mtg-checkbox", 16);
    ɵngcc0.ɵɵtext(16);
    ɵngcc0.ɵɵelementStart(17, "a", 17);
    ɵngcc0.ɵɵtext(18);
    ɵngcc0.ɵɵelementEnd()()();
    ɵngcc0.ɵɵelementStart(19, "div", 18)(20, "mtg-button", 19);
    ɵngcc0.ɵɵtext(21);
    ɵngcc0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formGroup", ctx_r1.form);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("label", ctx_r1.localization.name);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("label", ctx_r1.localization.surname);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("trim", true);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("label", ctx_r1.localization.city);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.localization.notSelected);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.cities);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("label", ctx_r1.localization.password)("trim", true);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("value", true);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.localization.agreement1, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("href", ctx_r1.agreementLink, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.localization.agreement2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("fluid", true);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.localization.register);
} }
function RegistrationComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 21);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.localization.successMessage, " ");
} }
function ResetPasswordComponent_form_3_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "form", 4);
    ɵngcc0.ɵɵlistener("submit", function ResetPasswordComponent_form_3_Template_form_submit_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r2.submit()); });
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵelement(2, "mtg-text-field", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 7)(4, "mtg-button", 8);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "mtg-button", 9);
    ɵngcc0.ɵɵlistener("click", function ResetPasswordComponent_form_3_Template_mtg_button_click_6_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r4.openLoginModal()); });
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.form);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("fluid", true);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.localization.send);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("fluid", true);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.localization.auth, " ");
} }
function ResetPasswordComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.localization.successMessage, " ");
} }
function LoginComponent_mtg_button_17_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mtg-button", 13);
    ɵngcc0.ɵɵlistener("click", function LoginComponent_mtg_button_17_Template_mtg_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r1.vkLogin()); });
    ɵngcc0.ɵɵelement(1, "mtg-svg-icon", 14);
    ɵngcc0.ɵɵelementEnd();
} }
class AuthorizationComponent {
}
AuthorizationComponent.ɵfac = function AuthorizationComponent_Factory(t) { return new (t || AuthorizationComponent)(); };
AuthorizationComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AuthorizationComponent, selectors: [["mtg-authorization"]], decls: 5, vars: 1, consts: [[1, "authorization"], [1, "header"], ["title", "MTGame", "alt", "MTGame", 1, "logo", 3, "src"], [1, "content"]], template: function AuthorizationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        ɵngcc0.ɵɵelement(2, "img", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelement(4, "router-outlet");
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("src", "/assets/logo.svg", ɵngcc0.ɵɵsanitizeUrl);
    } }, dependencies: [ɵngcc1.RouterOutlet], encapsulation: 2, changeDetection: 0 });

let ChangePasswordModel = class ChangePasswordModel extends BaseModel {
    static toBack(model) { }
};
__decorate([
    ToBackHook
], ChangePasswordModel, "toBack", null);
ChangePasswordModel = __decorate([
    ModelInstance({
        mappingFields: {
            uid: 'uid',
            token: 'token',
            password: 'password',
            password_confirm: 'passwordConfirm',
        }
    })
], ChangePasswordModel);

const FACEBOOK_APP_ID = '164936710911531';
const FACEBOOK_APP_VERSION = 'v7.0';
class FacebookService {
    constructor(configService) {
        this.configService = configService;
    }
    login() {
        const redirectUri = this.configService.get('portalHost') + '/assets/oauth/fb.html';
        const authResultEvent = 'fb-auth-result';
        return new Promise((resolve, reject) => {
            const url = `https://www.facebook.com/${FACEBOOK_APP_VERSION}/dialog/oauth?client_id=${FACEBOOK_APP_ID}&redirect_uri=${redirectUri}&response_type=code&scope=email,public_profile&display=popup&auth_type=rerequest&state=${window.location.origin}`;
            const loginWindow = window.open(url, 'fb_auth', 'width=400,height=400');
            const handleLogin = (evt) => {
                window.removeEventListener(authResultEvent, handleLogin);
                clearInterval(this.interval);
                if (!evt.detail) {
                    reject();
                    return;
                }
                resolve({
                    code: evt.detail,
                    redirectUri
                });
            };
            this.interval = setInterval(() => {
                if (loginWindow.closed) {
                    clearInterval(this.interval);
                    window.removeEventListener(authResultEvent, handleLogin);
                    reject();
                }
            }, 100);
            window.addEventListener(authResultEvent, handleLogin);
        });
    }
}
FacebookService.ɵfac = function FacebookService_Factory(t) { return new (t || FacebookService)(ɵngcc0.ɵɵinject(ɵngcc2.ConfigService)); };
FacebookService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: FacebookService, factory: FacebookService.ɵfac });
FacebookService.ctorParameters = () => [
    { type: ConfigService }
];

class VKService {
    constructor(configService) {
        this.configService = configService;
    }
    login() {
        return __awaiter(this, void 0, void 0, function* () {
            const redirectUri = this.configService.get('portalHost') + '/assets/oauth/vk.html?origin=' + window.location.origin;
            const apiId = 6256084;
            const eventAuthResult = 'vk-auth-result';
            return new Promise((resolve, reject) => {
                const url = `https://oauth.vk.com/authorize?client_id=${apiId}&redirect_uri=${redirectUri}&response_type=code&scope=email&display=popup`;
                const loginWindow = window.open(url, 'vk_auth', 'width=400,height=400');
                const handleLogin = (evt) => {
                    window.removeEventListener(eventAuthResult, handleLogin);
                    clearInterval(this.interval);
                    if (!evt.detail) {
                        reject();
                        return;
                    }
                    resolve({
                        code: evt.detail,
                        redirectUri
                    });
                };
                this.interval = setInterval(() => {
                    if (loginWindow && loginWindow.closed) {
                        window.removeEventListener(eventAuthResult, handleLogin);
                        reject();
                        clearInterval(this.interval);
                    }
                }, 100);
                window.addEventListener(eventAuthResult, handleLogin);
            });
        });
    }
}
VKService.ɵfac = function VKService_Factory(t) { return new (t || VKService)(ɵngcc0.ɵɵinject(ɵngcc2.ConfigService)); };
VKService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: VKService, factory: VKService.ɵfac });
VKService.ctorParameters = () => [
    { type: ConfigService }
];

let RegistrationModel = class RegistrationModel {
    static toBack(modelData) {
        return null;
    }
};
__decorate([
    ToBackHook
], RegistrationModel, "toBack", null);
RegistrationModel = __decorate([
    ModelInstance({
        mappingFields: {
            email: 'email',
            first_name: 'firstName',
            last_name: 'lastName',
            new_password: 'newPassword',
            city: 'city',
            timezone: 'timezone',
        }
    })
], RegistrationModel);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AuthorizationComponent, [{
        type: Component,
        args: [{
                selector: 'mtg-authorization',
                template: "<div class=\"authorization\">\n  <div class=\"header\">\n    <img [src]=\"'/assets/logo.svg'\" class=\"logo\" title=\"MTGame\" alt=\"MTGame\" />\n  </div>\n\n  <div class=\"content\">\n    <router-outlet></router-outlet>\n  </div>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FacebookService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc2.ConfigService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VKService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc2.ConfigService }]; }, null); })();

class AuthApi {
    constructor(httpClient, configService) {
        this.httpClient = httpClient;
        this.configService = configService;
    }
    currentUser() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .get(`${this.configService.get('apiUrl')}/api/v1/user/current/`)
                .pipe(map(response => User.toFront(response))).toPromise();
        });
    }
    refreshAuth(fingerprint) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .post(`${this.configService.get('apiUrl')}/api/v1/auth/refresh/`, { fingerprint }).toPromise();
        });
    }
    login(email, password, timezone, fingerprint) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = {
                email,
                password,
                timezone,
                fingerprint,
            };
            return this.httpClient
                .post(`${this.configService.get('apiUrl')}/api/v1/auth/jwt_login/`, payload)
                .pipe(map(response => (Object.assign(Object.assign({}, response), { user: User.toFront(response.user) })))).toPromise();
        });
    }
    registration(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .post(`${this.configService.get('apiUrl')}/api/v1/auth/registration/`, RegistrationModel.toBack(data))
                .pipe(map(response => User.toFront(response))).toPromise();
        });
    }
    logout() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .post(`${this.configService.get('apiUrl')}/api/v1/auth/jwt_logout/`, {}, { withCredentials: true })
                .toPromise();
        });
    }
    facebookLogin(payload, fingerprint) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .post(`${this.configService.get('apiUrl')}/api/v1/auth/jwt_facebook/`, {
                code: payload.code,
                redirect_uri: payload.redirectUri,
                fingerprint
            })
                .pipe(map(response => (Object.assign(Object.assign({}, response), { user: User.toFront(response.user) })))).toPromise();
        });
    }
    vkLogin(payload, fingerprint) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .post(`${this.configService.get('apiUrl')}/api/v1/auth/jwt_vk/`, {
                code: payload.code,
                redirect_uri: payload.redirectUri,
                fingerprint
            })
                .pipe(map(response => (Object.assign(Object.assign({}, response), { user: User.toFront(response.user) })))).toPromise();
        });
    }
    resetPassword(email) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .post(`${this.configService.get('apiUrl')}/api/v1/auth/reset_password/`, { email })
                .toPromise();
        });
    }
    changePassword(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .post(`${this.configService.get('apiUrl')}/api/v1/auth/change_password/`, ChangePasswordModel.toBack(data))
                .toPromise();
        });
    }
    checkEmail(email, selfCheck) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = new HttpParams()
                .set('email', email)
                .set('self_check', selfCheck ? '1' : '0');
            return this.httpClient
                .get(`${this.configService.get('apiUrl')}/api/v1/auth/check_email/`, { params })
                .pipe(map((data) => data.valid))
                .toPromise();
        });
    }
}
AuthApi.ɵfac = function AuthApi_Factory(t) { return new (t || AuthApi)(ɵngcc0.ɵɵinject(ɵngcc3.HttpClient), ɵngcc0.ɵɵinject(ɵngcc2.ConfigService)); };
AuthApi.ɵprov = i0.ɵɵdefineInjectable({ factory: function AuthApi_Factory() { return new AuthApi(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ConfigService)); }, token: AuthApi, providedIn: "root" });
AuthApi.ctorParameters = () => [
    { type: HttpClient },
    { type: ConfigService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AuthApi, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc3.HttpClient }, { type: ɵngcc2.ConfigService }]; }, null); })();

const STORE_USER_KEY = 'user';
const STORE_ACCESS_TOKEN_KEY = 'access_token';
const STORE_ACCESS_TOKEN_EXP_KEY = 'access_token_exp';
const STORE_REFRESH_TOKEN_KEY = 'refresh_token';
class AuthService {
    constructor(platformId, authApi) {
        this.platformId = platformId;
        this.authApi = authApi;
        this.store = new Store();
        this.isBrowser = isPlatformBrowser(this.platformId);
    }
    get user$() {
        return this.store.get(STORE_USER_KEY);
    }
    initialize() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const user = yield this.authApi.currentUser();
                this.store.save(STORE_USER_KEY, user);
                return user;
            }
            catch (e) {
                this.store.save(STORE_USER_KEY, null);
                return null;
            }
        });
    }
    getAccessToken() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isBrowser) {
                return Promise.resolve(this.store.value(STORE_ACCESS_TOKEN_KEY));
            }
            const accessToken = this.store.value(STORE_ACCESS_TOKEN_KEY);
            const accessTokenExp = this.store.value(STORE_ACCESS_TOKEN_EXP_KEY);
            if (!accessToken && accessToken !== undefined) {
                return Promise.resolve(null);
            }
            if (accessToken && accessTokenExp && (new Date()).getTime() < new Date(accessTokenExp * 1000).getTime()) {
                return Promise.resolve(accessToken);
            }
            try {
                const response = yield this.authApi.refreshAuth(yield this.getFingerprint());
                this.store.save(STORE_ACCESS_TOKEN_KEY, response.access_token);
                this.store.save(STORE_ACCESS_TOKEN_EXP_KEY, response.access_token_exp);
                this.store.save(STORE_REFRESH_TOKEN_KEY, response.refresh_token);
                return response.access_token;
            }
            catch (e) {
                this.store.save(STORE_ACCESS_TOKEN_KEY, null);
                return null;
            }
        });
    }
    login(email, password, timezone) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authApi.login(email, password, timezone, yield this.getFingerprint());
            this.saveAccessToken(response);
            return response.user;
        });
    }
    registration(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.authApi.registration(data);
        });
    }
    logout() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.authApi.logout();
            this.store.save(STORE_USER_KEY, null);
            this.store.save(STORE_ACCESS_TOKEN_KEY, null);
            this.store.save(STORE_ACCESS_TOKEN_EXP_KEY, null);
            this.store.save(STORE_REFRESH_TOKEN_KEY, null);
        });
    }
    facebookLogin(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authApi.facebookLogin(payload, yield this.getFingerprint());
            this.saveAccessToken(response);
            return response.user;
        });
    }
    vkLogin(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authApi.vkLogin(payload, yield this.getFingerprint());
            this.saveAccessToken(response);
            return response.user;
        });
    }
    resetPassword(email) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.authApi.resetPassword(email);
        });
    }
    changePassword(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.authApi.changePassword(payload);
        });
    }
    checkEmail(email, selfCheck) {
        return new Observable(observer => {
            this.authApi.checkEmail(email, selfCheck).then(result => {
                observer.next(result);
            }).catch(err => {
                observer.error(err);
            }).finally(() => {
                observer.complete();
            });
        });
    }
    saveAccessToken(response) {
        this.store.save(STORE_ACCESS_TOKEN_KEY, response.access_token);
        this.store.save(STORE_ACCESS_TOKEN_EXP_KEY, response.access_token_exp);
        this.store.save(STORE_REFRESH_TOKEN_KEY, response.refresh_token);
        this.store.save(STORE_USER_KEY, response.user);
    }
    getFingerprint() {
        return __awaiter(this, void 0, void 0, function* () {
            const options = {
                excludes: {
                    plugins: true,
                    localStorage: true,
                    adBlock: true,
                    screenResolution: true,
                    availableScreenResolution: true,
                    enumerateDevices: true,
                    pixelRatio: true,
                    doNotTrack: true
                },
                preprocessor: (key, value) => {
                    if (key === 'userAgent') {
                        const parser = new UAParser(value);
                        // return customized user agent (without browser version)
                        return `${parser.getOS().name} :: ${parser.getBrowser().name} :: ${parser.getEngine().name}`;
                    }
                    return value;
                }
            };
            const components = yield Fingerprint2.getPromise(options);
            const values = components.map(component => component.value);
            return String(Fingerprint2.x64hash128(values.join(''), 31));
        });
    }
}
AuthService.ɵfac = function AuthService_Factory(t) { return new (t || AuthService)(ɵngcc0.ɵɵinject(PLATFORM_ID), ɵngcc0.ɵɵinject(AuthApi)); };
AuthService.ɵprov = i0.ɵɵdefineInjectable({ factory: function AuthService_Factory() { return new AuthService(i0.ɵɵinject(i0.PLATFORM_ID), i0.ɵɵinject(AuthApi)); }, token: AuthService, providedIn: "root" });
AuthService.ctorParameters = () => [
    { type: String, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
    { type: AuthApi }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AuthService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: String, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }, { type: AuthApi }]; }, null); })();

const ROUTE_LOGIN = 'login';
const ROUTE_REGISTRATION = 'registration';
const ROUTE_RESET_PASSWORD = 'reset-password';
const ROUTE_CHANGE_PASSWORD = 'change-password';

var registrationLocalization = {
    [Locales.ru]: {
        title: 'Регистрация',
        hint: 'Уже зарегистрированны?',
        auth: 'Авторизация',
        name: 'Имя',
        surname: 'Фамилия',
        city: 'Город',
        notSelected: 'Не выбрано',
        password: 'Пароль',
        agreement1: 'Я соглашаюсь с',
        agreement2: 'политикой обработки и хранения персональных данных',
        register: 'Зарегистрироваться',
        successMessage: 'Спасибо за регистрацию. На вашу почту %email% отправлено письмо с ссылкой для активации учетной записи.',
        sendEmailError: 'Ошибка при отправке email. Проверьте корректность введеного email',
        agreementError: 'Вам необходимо согласиться с политикой обработки и хранения персональных данных',
        error: 'Ошибка',
    },
    [Locales.en]: {
        title: 'Registration',
        hint: 'Already registered?',
        auth: 'Authorization',
        name: 'Name',
        surname: 'Surname',
        city: 'City',
        notSelected: 'Not selected',
        password: 'Password',
        agreement1: 'I agree with',
        agreement2: 'the policy of processing and storing personal data',
        register: 'Register',
        successMessage: 'Thank you for registering. An email with a link to activate your account has been sent to your email address %email%.',
        sendEmailError: 'Error sending email. Check if the email you entered is correct.',
        agreementError: 'You must agree to the personal data processing and storage policy',
        error: 'Error',
    }
};

class RegistrationComponent {
    constructor(router, fb, authService, toastService, dialogService, referenceApi, route, configService, dialogRef, dialogConfig, localizationService, cdr) {
        this.router = router;
        this.fb = fb;
        this.authService = authService;
        this.toastService = toastService;
        this.dialogService = dialogService;
        this.referenceApi = referenceApi;
        this.route = route;
        this.configService = configService;
        this.dialogRef = dialogRef;
        this.dialogConfig = dialogConfig;
        this.localizationService = localizationService;
        this.cdr = cdr;
        this.isSuccess = false;
        this.isLoading = false;
        this.localization = registrationLocalization[this.localizationService.getLocale()];
    }
    get agreementLink() {
        if (this.localizationService.getLocale() === Locales.en) {
            return 'https://mtgame-sports.com/privacy_policy';
        }
        else {
            return 'https://mtgame.ru/privacy_policy';
        }
    }
    get successMessage() {
        return this.localization.successMessage.replace('email', this.form.get('email').value);
    }
    ngOnInit() {
        this.isModal = !!this.dialogRef;
        this.form = this.fb.group({
            email: new FormControl(null, [Validators.required, Validators.email], validateEmail(this.authService)),
            firstName: new FormControl(null, [Validators.required]),
            lastName: new FormControl(null, [Validators.required]),
            newPassword: new FormControl(null, [Validators.required]),
            agreement: new FormControl(null, [Validators.required]),
            city: new FormControl(null),
        });
        this.referenceApi.getCities().then(cities => {
            this.cities = cities;
        });
    }
    submit() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isLoading) {
                return;
            }
            markFormGroupTouched(this.form);
            if (this.form.valid) {
                this.isLoading = true;
                try {
                    yield this.authService.registration(Object.assign(Object.assign({}, this.form.value), { timezone: getTimezone() }));
                    this.isSuccess = true;
                }
                catch (e) {
                    if (e.error.error === 'Send email error') {
                        this.toastService.danger(this.localization.sendEmailError);
                    }
                    else {
                        handleError(e);
                        this.toastService.danger(this.localization.error);
                    }
                }
                finally {
                    this.isLoading = false;
                    this.cdr.markForCheck();
                }
            }
            else if (!this.form.value.agreement) {
                this.toastService.danger(this.localization.agreementError);
            }
        });
    }
    agreementModal() {
        // this.dialogService.open(AgreementComponent, {
        //   isCloseButtonVisible: true
        // });
    }
    openLoginModal() {
        if (this.isModal) {
            this.dialogService.open(LoginComponent, this.dialogConfig, this.dialogRef);
        }
        else {
            this.router.navigate([
                this.configService.get('authRoute'),
                ROUTE_LOGIN
            ], { queryParams: this.queryParams });
        }
    }
    get queryParams() {
        return this.route.snapshot.queryParams;
    }
}
RegistrationComponent.ɵfac = function RegistrationComponent_Factory(t) { return new (t || RegistrationComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.Router), ɵngcc0.ɵɵdirectiveInject(ɵngcc4.FormBuilder), ɵngcc0.ɵɵdirectiveInject(AuthService), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.ToastService), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.DialogService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.ReferenceApi), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.ActivatedRoute), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.ConfigService), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.DialogRef, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.DialogConfig, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.LocalizationService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
RegistrationComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: RegistrationComponent, selectors: [["mtg-registration"]], decls: 6, vars: 4, consts: [[1, "authorization-form"], [1, "title"], ["class", "hint", 4, "ngIf"], [3, "formGroup", "submit", 4, "ngIf"], ["class", "success", 4, "ngIf"], [1, "hint"], ["href", "javascript:;", 1, "link", 3, "click"], [3, "formGroup", "submit"], [1, "form-field"], ["formControlName", "firstName", 3, "label"], ["formControlName", "lastName", 3, "label"], ["formControlName", "email", "label", "Email", 3, "trim"], ["formControlName", "city", 3, "label"], [3, "value", 4, "ngFor", "ngForOf"], ["formControlName", "newPassword", "type", "password", 3, "label", "trim"], [1, "form-field", "agreement"], ["formControlName", "agreement", 3, "value"], ["target", "_blank", 1, "link", 3, "href"], [1, "submit-field"], ["type", "submit", "size", "lg", 3, "fluid"], [3, "value"], [1, "success"]], template: function RegistrationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, RegistrationComponent_div_3_Template, 4, 2, "div", 2);
        ɵngcc0.ɵɵtemplate(4, RegistrationComponent_form_4_Template, 22, 15, "form", 3);
        ɵngcc0.ɵɵtemplate(5, RegistrationComponent_div_5_Template, 2, 1, "div", 4);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.localization.title);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isSuccess);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isSuccess);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isSuccess);
    } }, dependencies: [ɵngcc6.NgForOf, ɵngcc6.NgIf, ɵngcc4.ɵNgNoValidate, ɵngcc4.NgControlStatus, ɵngcc4.NgControlStatusGroup, ɵngcc4.FormGroupDirective, ɵngcc4.FormControlName, ɵngcc5.ButtonComponent, ɵngcc5.TextFieldComponent, ɵngcc5.DropdownComponent, ɵngcc5.DropdownItemComponent, ɵngcc5.CheckboxComponent, ɵngcc5.CityNamePipe], encapsulation: 2, changeDetection: 0 });
RegistrationComponent.ctorParameters = () => [
    { type: Router },
    { type: FormBuilder },
    { type: AuthService },
    { type: ToastService },
    { type: DialogService },
    { type: ReferenceApi },
    { type: ActivatedRoute },
    { type: ConfigService },
    { type: DialogRef, decorators: [{ type: Optional }] },
    { type: DialogConfig, decorators: [{ type: Optional }] },
    { type: LocalizationService },
    { type: ChangeDetectorRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RegistrationComponent, [{
        type: Component,
        args: [{
                selector: 'mtg-registration',
                template: "<div class=\"authorization-form\">\n  <div class=\"title\">{{ localization.title }}</div>\n  <div class=\"hint\" *ngIf=\"!isSuccess\">\n    {{ localization.hint }}\n    <a href=\"javascript:;\" class=\"link\" (click)=\"openLoginModal()\">{{ localization.auth }}</a>\n  </div>\n  <form [formGroup]=\"form\" (submit)=\"submit()\" *ngIf=\"!isSuccess\">\n    <div class=\"form-field\">\n      <mtg-text-field\n        formControlName=\"firstName\"\n        [label]=\"localization.name\"\n      ></mtg-text-field>\n    </div>\n    <div class=\"form-field\">\n      <mtg-text-field\n        formControlName=\"lastName\"\n        [label]=\"localization.surname\"\n      ></mtg-text-field>\n    </div>\n    <div class=\"form-field\">\n      <mtg-text-field\n        formControlName=\"email\"\n        label=\"Email\"\n        [trim]=\"true\"\n      ></mtg-text-field>\n    </div>\n    <div class=\"form-field\">\n      <mtg-dropdown\n        formControlName=\"city\"\n        [label]=\"localization.city\"\n      >\n        <mtg-dropdown-item>{{ localization.notSelected }}</mtg-dropdown-item>\n        <mtg-dropdown-item\n          *ngFor=\"let item of cities\"\n          [value]=\"item\"\n        >{{ item | mtgCityName }}</mtg-dropdown-item>\n      </mtg-dropdown>\n    </div>\n    <div class=\"form-field\">\n      <mtg-text-field\n        formControlName=\"newPassword\"\n        [label]=\"localization.password\"\n        type=\"password\"\n        [trim]=\"true\"\n      ></mtg-text-field>\n    </div>\n    <div class=\"form-field agreement\">\n      <mtg-checkbox formControlName=\"agreement\" [value]=\"true\">\n        {{ localization.agreement1 }}\n        <a [href]=\"agreementLink\" target=\"_blank\" class=\"link\">{{ localization.agreement2 }}</a>\n      </mtg-checkbox>\n    </div>\n    <div class=\"submit-field\">\n      <mtg-button [fluid]=\"true\" type=\"submit\" size=\"lg\">{{ localization.register }}</mtg-button>\n    </div>\n  </form>\n  <div class=\"success\" *ngIf=\"isSuccess\">\n    {{ localization.successMessage }}\n  </div>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc1.Router }, { type: ɵngcc4.FormBuilder }, { type: AuthService }, { type: ɵngcc5.ToastService }, { type: ɵngcc5.DialogService }, { type: ɵngcc2.ReferenceApi }, { type: ɵngcc1.ActivatedRoute }, { type: ɵngcc2.ConfigService }, { type: ɵngcc5.DialogRef, decorators: [{
                type: Optional
            }] }, { type: ɵngcc5.DialogConfig, decorators: [{
                type: Optional
            }] }, { type: ɵngcc5.LocalizationService }, { type: ɵngcc0.ChangeDetectorRef }]; }, null); })();

var resetPasswordLocalization = {
    [Locales.ru]: {
        title: 'Сброс пароля',
        send: 'Отправить',
        auth: 'Авторизация',
        successMessage: 'Инструкции по восстановлению пароля были отправлены на ваш email.',
        userNotFound: 'Пользователь не найден',
        sendEmailError: 'Ошибка при отправке email. Попробуйте еще раз или напишите в техподдержку.',
        error: 'Ошибка',
    },
    [Locales.en]: {
        title: 'Reset password',
        send: 'Send',
        auth: 'Authorization',
        successMessage: 'Password recovery instructions have been sent to your email.',
        userNotFound: 'User not found',
        sendEmailError: 'Error sending email. Try again or contact technical support.',
        error: 'Error',
    },
};

class ResetPasswordComponent {
    constructor(router, fb, authService, toastService, route, dialogService, configService, dialogRef, dialogConfig, localizationService, cdr) {
        this.router = router;
        this.fb = fb;
        this.authService = authService;
        this.toastService = toastService;
        this.route = route;
        this.dialogService = dialogService;
        this.configService = configService;
        this.dialogRef = dialogRef;
        this.dialogConfig = dialogConfig;
        this.localizationService = localizationService;
        this.cdr = cdr;
        this.isSucceed = false;
        this.isLoading = false;
        this.localization = resetPasswordLocalization[this.localizationService.getLocale()];
    }
    ngOnInit() {
        this.isModal = !!this.dialogRef;
        this.form = this.fb.group({
            email: new FormControl(null, [Validators.required, Validators.email])
        });
    }
    submit() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.form.valid) {
                this.isLoading = true;
                try {
                    yield this.authService.resetPassword(this.form.get('email').value);
                    this.isSucceed = true;
                }
                catch (e) {
                    const errors = e.error;
                    if (errors.email) {
                        this.toastService.danger(this.localization.userNotFound);
                    }
                    else if (errors.error === 'Send email error') {
                        this.toastService.danger(this.localization.sendEmailError);
                    }
                    else {
                        handleError(e);
                        this.toastService.danger(this.localization.error);
                    }
                }
                finally {
                    this.isLoading = false;
                    this.cdr.markForCheck();
                }
            }
        });
    }
    openLoginModal() {
        if (this.isModal) {
            this.dialogService.open(LoginComponent, this.dialogConfig, this.dialogRef);
        }
        else {
            this.router.navigate([
                this.configService.get('authRoute'),
                ROUTE_LOGIN
            ], { queryParams: this.queryParams });
        }
    }
    get queryParams() {
        return this.route.snapshot.queryParams;
    }
}
ResetPasswordComponent.ɵfac = function ResetPasswordComponent_Factory(t) { return new (t || ResetPasswordComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.Router), ɵngcc0.ɵɵdirectiveInject(ɵngcc4.FormBuilder), ɵngcc0.ɵɵdirectiveInject(AuthService), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.ToastService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.ActivatedRoute), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.DialogService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.ConfigService), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.DialogRef, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.DialogConfig, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.LocalizationService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
ResetPasswordComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ResetPasswordComponent, selectors: [["mtg-reset-password"]], decls: 5, vars: 3, consts: [[1, "authorization-form"], [1, "title"], [3, "formGroup", "submit", 4, "ngIf"], ["class", "success", 4, "ngIf"], [3, "formGroup", "submit"], [1, "form-field"], ["formControlName", "email", "label", "Email"], [1, "form-field", "submit-field"], ["type", "submit", "size", "lg", 3, "fluid"], ["color", "secondary", "variant", "link", 3, "fluid", "click"], [1, "success"]], template: function ResetPasswordComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, ResetPasswordComponent_form_3_Template, 8, 5, "form", 2);
        ɵngcc0.ɵɵtemplate(4, ResetPasswordComponent_div_4_Template, 2, 1, "div", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.localization.title);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isSucceed);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isSucceed);
    } }, dependencies: [ɵngcc6.NgIf, ɵngcc4.ɵNgNoValidate, ɵngcc4.NgControlStatus, ɵngcc4.NgControlStatusGroup, ɵngcc4.FormGroupDirective, ɵngcc4.FormControlName, ɵngcc5.ButtonComponent, ɵngcc5.TextFieldComponent], encapsulation: 2, changeDetection: 0 });
ResetPasswordComponent.ctorParameters = () => [
    { type: Router },
    { type: FormBuilder },
    { type: AuthService },
    { type: ToastService },
    { type: ActivatedRoute },
    { type: DialogService },
    { type: ConfigService },
    { type: DialogRef, decorators: [{ type: Optional }] },
    { type: DialogConfig, decorators: [{ type: Optional }] },
    { type: LocalizationService },
    { type: ChangeDetectorRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ResetPasswordComponent, [{
        type: Component,
        args: [{
                selector: 'mtg-reset-password',
                template: "<div class=\"authorization-form\">\n  <div class=\"title\">{{ localization.title }}</div>\n  <form [formGroup]=\"form\" (submit)=\"submit()\" *ngIf=\"!isSucceed\">\n    <div class=\"form-field\">\n      <mtg-text-field\n        formControlName=\"email\"\n        label=\"Email\"\n      ></mtg-text-field>\n    </div>\n    <div class=\"form-field submit-field\">\n      <mtg-button [fluid]=\"true\" type=\"submit\" size=\"lg\">{{ localization.send }}</mtg-button>\n      <mtg-button [fluid]=\"true\" color=\"secondary\" (click)=\"openLoginModal()\" variant=\"link\">\n        {{ localization.auth }}\n      </mtg-button>\n    </div>\n  </form>\n  <div class=\"success\" *ngIf=\"isSucceed\">\n    {{ localization.successMessage }}\n  </div>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc1.Router }, { type: ɵngcc4.FormBuilder }, { type: AuthService }, { type: ɵngcc5.ToastService }, { type: ɵngcc1.ActivatedRoute }, { type: ɵngcc5.DialogService }, { type: ɵngcc2.ConfigService }, { type: ɵngcc5.DialogRef, decorators: [{
                type: Optional
            }] }, { type: ɵngcc5.DialogConfig, decorators: [{
                type: Optional
            }] }, { type: ɵngcc5.LocalizationService }, { type: ɵngcc0.ChangeDetectorRef }]; }, null); })();

var loginLocalization = {
    [Locales.ru]: {
        title: 'Авторизация',
        hint: 'Еще нет аккаунта MTGame?',
        registration: 'Регистрация',
        password: 'Пароль',
        forgotPassword: 'Забыли пароль?',
        login: 'Войти',
        passwordIncorrect: 'Логин или пароль введены неверно',
        error: 'Ошибка авторизации',
    },
    [Locales.en]: {
        title: 'Authorization',
        hint: 'Don\'t have an MTGame account yet?',
        registration: 'Registration',
        password: 'Password',
        forgotPassword: 'Forgot your password?',
        login: 'Login',
        passwordIncorrect: 'Login or password entered incorrectly',
        error: 'Authorization error',
    }
};

class LoginComponent {
    constructor(fb, router, authService, facebookService, vkService, toastService, route, dialogService, configService, dialogRef, dialogConfig, localizationService, cdr) {
        this.fb = fb;
        this.router = router;
        this.authService = authService;
        this.facebookService = facebookService;
        this.vkService = vkService;
        this.toastService = toastService;
        this.route = route;
        this.dialogService = dialogService;
        this.configService = configService;
        this.dialogRef = dialogRef;
        this.dialogConfig = dialogConfig;
        this.localizationService = localizationService;
        this.cdr = cdr;
        this.isLoading = false;
        this.localization = loginLocalization[this.localizationService.getLocale()];
        this.locale = this.localizationService.getLocale();
        this.locales = Locales;
    }
    ngOnInit() {
        this.isModal = !!this.dialogRef;
        this.form = this.fb.group({
            email: new FormControl('', [Validators.required, Validators.email]),
            password: new FormControl('', [Validators.required])
        });
    }
    submit() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.form.valid) {
                this.loginLoading = true;
                const formData = this.form.value;
                try {
                    const user = yield this.authService.login(formData.email, formData.password, getTimezone());
                    yield this.loginSuccess(user);
                }
                catch (e) {
                    if (e.status === 401) {
                        this.toastService.danger(this.localization.passwordIncorrect);
                    }
                    else {
                        handleError(e);
                        this.toastService.danger(this.localization.error);
                    }
                }
                finally {
                    this.loginLoading = false;
                    this.cdr.markForCheck();
                }
            }
        });
    }
    facebookLogin() {
        return __awaiter(this, void 0, void 0, function* () {
            this.facebookLoading = true;
            try {
                const data = yield this.facebookService.login();
                const user = yield this.authService.facebookLogin(data);
                yield this.loginSuccess(user);
            }
            catch (e) {
                if (e) {
                    handleError(e);
                }
                this.toastService.danger(this.localization.error);
            }
            finally {
                this.facebookLoading = false;
            }
        });
    }
    vkLogin() {
        return __awaiter(this, void 0, void 0, function* () {
            this.vkLoading = true;
            try {
                const data = yield this.vkService.login();
                const user = yield this.authService.vkLogin(data);
                yield this.loginSuccess(user);
            }
            catch (e) {
                handleError(e);
                this.toastService.danger(this.localization.error);
            }
            finally {
                this.vkLoading = false;
            }
        });
    }
    openRegistrationModal() {
        if (this.isModal) {
            this.dialogService.open(RegistrationComponent, this.dialogConfig, this.dialogRef);
        }
        else {
            this.router.navigate([
                this.configService.get('authRoute'),
                ROUTE_REGISTRATION
            ], { queryParams: this.queryParams });
        }
    }
    openResetPasswordModal() {
        if (this.isModal) {
            this.dialogService.open(ResetPasswordComponent, this.dialogConfig, this.dialogRef);
        }
        else {
            this.router.navigate([
                this.configService.get('authRoute'),
                ROUTE_RESET_PASSWORD
            ], { queryParams: this.queryParams });
        }
    }
    loginSuccess(user) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isModal) {
                this.dialogRef.close(user);
            }
            else if (this.queryParams.backUrl) {
                try {
                    yield this.router.navigateByUrl(this.queryParams.backUrl);
                }
                catch (e) {
                    handleError(e);
                    yield this.router.navigate(['/']);
                }
            }
            else {
                yield this.router.navigate(['/']);
            }
        });
    }
    get queryParams() {
        return this.route.snapshot.queryParams;
    }
}
LoginComponent.ɵfac = function LoginComponent_Factory(t) { return new (t || LoginComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc4.FormBuilder), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.Router), ɵngcc0.ɵɵdirectiveInject(AuthService), ɵngcc0.ɵɵdirectiveInject(FacebookService), ɵngcc0.ɵɵdirectiveInject(VKService), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.ToastService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.ActivatedRoute), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.DialogService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.ConfigService), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.DialogRef, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.DialogConfig, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.LocalizationService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
LoginComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: LoginComponent, selectors: [["mtg-login"]], decls: 20, vars: 11, consts: [[1, "authorization-form", "login-form"], [1, "title"], [1, "hint"], ["href", "javascript:;", 1, "link", 3, "click"], [3, "formGroup", "submit"], [1, "form-field"], ["label", "Email", "formControlName", "email", 3, "trim"], ["type", "password", "formControlName", "password", 3, "label", "trim"], [1, "form-field", "reset-password-link"], [1, "submit-field"], [1, "social-auth"], ["color", "secondary", "variant", "circle", "size", "lg", 3, "click", 4, "ngIf"], ["type", "submit", "size", "lg", 3, "fluid"], ["color", "secondary", "variant", "circle", "size", "lg", 3, "click"], ["icon", "icons-vkontakte"]], template: function LoginComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementStart(5, "a", 3);
        ɵngcc0.ɵɵlistener("click", function LoginComponent_Template_a_click_5_listener() { return ctx.openRegistrationModal(); });
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(7, "form", 4);
        ɵngcc0.ɵɵlistener("submit", function LoginComponent_Template_form_submit_7_listener() { return ctx.submit(); });
        ɵngcc0.ɵɵelementStart(8, "div", 5);
        ɵngcc0.ɵɵelement(9, "mtg-text-field", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "div", 5);
        ɵngcc0.ɵɵelement(11, "mtg-text-field", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "div", 8)(13, "a", 3);
        ɵngcc0.ɵɵlistener("click", function LoginComponent_Template_a_click_13_listener() { return ctx.openResetPasswordModal(); });
        ɵngcc0.ɵɵtext(14);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(15, "div", 9)(16, "div", 10);
        ɵngcc0.ɵɵtemplate(17, LoginComponent_mtg_button_17_Template, 2, 0, "mtg-button", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "mtg-button", 12);
        ɵngcc0.ɵɵtext(19);
        ɵngcc0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.localization.title);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.localization.hint, " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.localization.registration);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formGroup", ctx.form);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("trim", true);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("label", ctx.localization.password)("trim", true);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.localization.forgotPassword);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.locale === ctx.locales.ru);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("fluid", true);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.localization.login);
    } }, dependencies: [ɵngcc6.NgIf, ɵngcc4.ɵNgNoValidate, ɵngcc4.NgControlStatus, ɵngcc4.NgControlStatusGroup, ɵngcc4.FormGroupDirective, ɵngcc4.FormControlName, ɵngcc5.ButtonComponent, ɵngcc5.TextFieldComponent, ɵngcc5.SvgIconComponent], encapsulation: 2, changeDetection: 0 });
LoginComponent.ctorParameters = () => [
    { type: FormBuilder },
    { type: Router },
    { type: AuthService },
    { type: FacebookService },
    { type: VKService },
    { type: ToastService },
    { type: ActivatedRoute },
    { type: DialogService },
    { type: ConfigService },
    { type: DialogRef, decorators: [{ type: Optional }] },
    { type: DialogConfig, decorators: [{ type: Optional }] },
    { type: LocalizationService },
    { type: ChangeDetectorRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LoginComponent, [{
        type: Component,
        args: [{
                selector: 'mtg-login',
                template: "<div class=\"authorization-form login-form\">\n  <div class=\"title\">{{ localization.title }}</div>\n  <div class=\"hint\">\n    {{ localization.hint }}\n    <a href=\"javascript:;\" class=\"link\" (click)=\"openRegistrationModal()\">{{ localization.registration }}</a>\n  </div>\n  <form [formGroup]=\"form\" (submit)=\"submit()\">\n    <div class=\"form-field\">\n      <mtg-text-field\n        label=\"Email\"\n        formControlName=\"email\"\n        [trim]=\"true\"\n      ></mtg-text-field>\n    </div>\n    <div class=\"form-field\">\n      <mtg-text-field\n        [label]=\"localization.password\"\n        type=\"password\"\n        formControlName=\"password\"\n        [trim]=\"true\"\n      ></mtg-text-field>\n    </div>\n\n    <div class=\"form-field reset-password-link\">\n      <a href=\"javascript:;\" class=\"link\" (click)=\"openResetPasswordModal()\">{{ localization.forgotPassword }}</a>\n    </div>\n\n    <div class=\"submit-field\">\n      <div class=\"social-auth\">\n        <!--<mtg-button\n          color=\"secondary\"\n          variant=\"circle\"\n          size=\"lg\"\n          (click)=\"facebookLogin()\"\n        ><mtg-svg-icon icon=\"icons-facebook\"></mtg-svg-icon></mtg-button>-->\n        <mtg-button\n          *ngIf=\"locale === locales.ru\"\n          color=\"secondary\"\n          variant=\"circle\"\n          size=\"lg\"\n          (click)=\"vkLogin()\"\n        ><mtg-svg-icon icon=\"icons-vkontakte\"></mtg-svg-icon></mtg-button>\n      </div>\n\n      <mtg-button [fluid]=\"true\" type=\"submit\" size=\"lg\">{{ localization.login }}</mtg-button>\n    </div>\n  </form>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc4.FormBuilder }, { type: ɵngcc1.Router }, { type: AuthService }, { type: FacebookService }, { type: VKService }, { type: ɵngcc5.ToastService }, { type: ɵngcc1.ActivatedRoute }, { type: ɵngcc5.DialogService }, { type: ɵngcc2.ConfigService }, { type: ɵngcc5.DialogRef, decorators: [{
                type: Optional
            }] }, { type: ɵngcc5.DialogConfig, decorators: [{
                type: Optional
            }] }, { type: ɵngcc5.LocalizationService }, { type: ɵngcc0.ChangeDetectorRef }]; }, null); })();

var changePasswordLocalization = {
    [Locales.ru]: {
        title: 'Смена пароля',
        auth: 'Авторизация',
        password: 'Пароль',
        repeatPassword: 'Повторите пароль',
        change: 'Сменить',
        success: 'Пароль был изменен',
        error: 'Произошла ошибка. Если она повторится, то, пожалуйста, обратитесь в поддержку MTGame',
    },
    [Locales.en]: {
        title: 'Change password',
        auth: 'Authorization',
        password: 'Password',
        repeatPassword: 'Repeat password',
        change: 'Change',
        success: 'The password has been changed',
        error: 'An error has occurred. If it occurs again, please contact MTGame support',
    },
};

class ChangePasswordComponent {
    constructor(fb, router, route, authService, toastService, dialogService, dialogRef, dialogConfig, localizationService, cdr) {
        this.fb = fb;
        this.router = router;
        this.route = route;
        this.authService = authService;
        this.toastService = toastService;
        this.dialogService = dialogService;
        this.dialogRef = dialogRef;
        this.dialogConfig = dialogConfig;
        this.localizationService = localizationService;
        this.cdr = cdr;
        this.isLoading = false;
        this.localization = changePasswordLocalization[this.localizationService.getLocale()];
    }
    ngOnInit() {
        this.form = this.fb.group({
            uid: new FormControl(null),
            token: new FormControl(null),
            email: new FormControl({ value: null, disabled: true }),
            password: new FormControl(null, [Validators.required, Validators.minLength(6)]),
            passwordConfirm: new FormControl(null, [Validators.required, Validators.minLength(6)])
        }, { validator: this.checkPassword });
        this.route.queryParams.subscribe(queryParams => {
            this.form.patchValue({
                email: queryParams.email,
                uid: queryParams.uid,
                token: queryParams.token
            });
        });
    }
    submit() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.form.valid) {
                this.isLoading = true;
                const data = new ChangePasswordModel(this.form.value);
                try {
                    yield this.authService.changePassword(data);
                    this.openLogin();
                    this.toastService.success(this.localization.success);
                }
                catch (e) {
                    handleError(e);
                    this.toastService.danger(this.localization.error);
                }
                finally {
                    this.isLoading = false;
                    this.cdr.markForCheck();
                }
            }
        });
    }
    checkPassword(form) {
        if (form.get('passwordConfirm').errors) {
            return null;
        }
        if (form.get('password').value !== form.get('passwordConfirm').value) {
            form.get('passwordConfirm').setErrors({ mismatch: true });
        }
        else {
            form.get('passwordConfirm').setErrors(null);
        }
    }
    openLogin() {
        this.dialogService.open(LoginComponent, this.dialogConfig, this.dialogRef);
    }
}
ChangePasswordComponent.ɵfac = function ChangePasswordComponent_Factory(t) { return new (t || ChangePasswordComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc4.FormBuilder), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.Router), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.ActivatedRoute), ɵngcc0.ɵɵdirectiveInject(AuthService), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.ToastService), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.DialogService), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.DialogRef, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.DialogConfig, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.LocalizationService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
ChangePasswordComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ChangePasswordComponent, selectors: [["mtg-change-password"]], decls: 15, vars: 7, consts: [[1, "authorization-form"], [1, "title"], ["href", "javascript:;", 3, "click"], [3, "formGroup", "submit"], [1, "form-field"], ["label", "Email", "formControlName", "email", 3, "disabled"], ["formControlName", "password", "type", "password", 3, "label"], ["type", "password", "formControlName", "passwordConfirm", 3, "label"], [1, "submit-field"], ["type", "submit"]], template: function ChangePasswordComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "a", 2);
        ɵngcc0.ɵɵlistener("click", function ChangePasswordComponent_Template_a_click_3_listener() { return ctx.openLogin(); });
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "form", 3);
        ɵngcc0.ɵɵlistener("submit", function ChangePasswordComponent_Template_form_submit_5_listener() { return ctx.submit(); });
        ɵngcc0.ɵɵelementStart(6, "div", 4);
        ɵngcc0.ɵɵelement(7, "mtg-text-field", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 4);
        ɵngcc0.ɵɵelement(9, "mtg-text-field", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "div", 4);
        ɵngcc0.ɵɵelement(11, "mtg-text-field", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "div", 8)(13, "mtg-button", 9);
        ɵngcc0.ɵɵtext(14);
        ɵngcc0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.localization.title);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.localization.auth);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formGroup", ctx.form);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("disabled", true);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("label", ctx.localization.password);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("label", ctx.localization.repeatPassword);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.localization.change);
    } }, dependencies: [ɵngcc4.ɵNgNoValidate, ɵngcc4.NgControlStatus, ɵngcc4.NgControlStatusGroup, ɵngcc4.FormGroupDirective, ɵngcc4.FormControlName, ɵngcc5.ButtonComponent, ɵngcc5.TextFieldComponent], encapsulation: 2, changeDetection: 0 });
ChangePasswordComponent.ctorParameters = () => [
    { type: FormBuilder },
    { type: Router },
    { type: ActivatedRoute },
    { type: AuthService },
    { type: ToastService },
    { type: DialogService },
    { type: DialogRef, decorators: [{ type: Optional }] },
    { type: DialogConfig, decorators: [{ type: Optional }] },
    { type: LocalizationService },
    { type: ChangeDetectorRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ChangePasswordComponent, [{
        type: Component,
        args: [{
                selector: 'mtg-change-password',
                template: "<div class=\"authorization-form\">\n  <div class=\"title\">{{ localization.title }}</div>\n  <a href=\"javascript:;\" (click)=\"openLogin()\">{{ localization.auth }}</a>\n  <form [formGroup]=\"form\" (submit)=\"submit()\">\n    <div class=\"form-field\">\n      <mtg-text-field\n        label=\"Email\"\n        [disabled]=\"true\"\n        formControlName=\"email\"\n      ></mtg-text-field>\n    </div>\n    <div class=\"form-field\">\n      <mtg-text-field\n        [label]=\"localization.password\"\n        formControlName=\"password\"\n        type=\"password\"\n      ></mtg-text-field>\n    </div>\n    <div class=\"form-field\">\n      <mtg-text-field\n        [label]=\"localization.repeatPassword\"\n        type=\"password\"\n        formControlName=\"passwordConfirm\"\n      ></mtg-text-field>\n    </div>\n    <div class=\"submit-field\">\n      <mtg-button type=\"submit\">{{ localization.change }}</mtg-button>\n    </div>\n  </form>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc4.FormBuilder }, { type: ɵngcc1.Router }, { type: ɵngcc1.ActivatedRoute }, { type: AuthService }, { type: ɵngcc5.ToastService }, { type: ɵngcc5.DialogService }, { type: ɵngcc5.DialogRef, decorators: [{
                type: Optional
            }] }, { type: ɵngcc5.DialogConfig, decorators: [{
                type: Optional
            }] }, { type: ɵngcc5.LocalizationService }, { type: ɵngcc0.ChangeDetectorRef }]; }, null); })();

class JwtAuthInterceptor {
    constructor(authService, configService) {
        this.authService = authService;
        this.configService = configService;
    }
    intercept(req, next) {
        if (req.url.indexOf(`${this.configService.get('apiUrl')}/api/v1/auth/`) === 0) {
            return next.handle(req);
        }
        return from(this.authService.getAccessToken()).pipe(switchMap(accessToken => {
            if (accessToken) {
                const headers = req.headers.set('Authorization', `Bearer ${accessToken}`);
                req = req.clone({ headers });
            }
            return next.handle(req);
        }));
    }
}
JwtAuthInterceptor.ɵfac = function JwtAuthInterceptor_Factory(t) { return new (t || JwtAuthInterceptor)(ɵngcc0.ɵɵinject(AuthService), ɵngcc0.ɵɵinject(ɵngcc2.ConfigService)); };
JwtAuthInterceptor.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: JwtAuthInterceptor, factory: JwtAuthInterceptor.ɵfac });
JwtAuthInterceptor.ctorParameters = () => [
    { type: AuthService },
    { type: ConfigService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(JwtAuthInterceptor, [{
        type: Injectable
    }], function () { return [{ type: AuthService }, { type: ɵngcc2.ConfigService }]; }, null); })();

class AuthorizationModule {
}
AuthorizationModule.ɵfac = function AuthorizationModule_Factory(t) { return new (t || AuthorizationModule)(); };
AuthorizationModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: AuthorizationModule });
AuthorizationModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        FacebookService,
        VKService
    ], imports: [CommonModule,
        RouterModule,
        FormsModule,
        HttpClientModule,
        ReactiveFormsModule,
        RouterModule,
        ButtonModule,
        TextFieldModule,
        DropdownModule,
        CheckboxModule,
        ToastModule,
        DialogModule,
        SvgIconModule,
        LocalizationModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AuthorizationModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    RouterModule,
                    FormsModule,
                    HttpClientModule,
                    ReactiveFormsModule,
                    RouterModule,
                    ButtonModule,
                    TextFieldModule,
                    DropdownModule,
                    CheckboxModule,
                    ToastModule,
                    DialogModule,
                    SvgIconModule,
                    LocalizationModule,
                ],
                declarations: [
                    AuthorizationComponent,
                    LoginComponent,
                    RegistrationComponent,
                    ResetPasswordComponent,
                    ChangePasswordComponent,
                ],
                providers: [
                    FacebookService,
                    VKService
                ],
                exports: [
                    AuthorizationComponent,
                    LoginComponent,
                    RegistrationComponent,
                    ResetPasswordComponent,
                    ChangePasswordComponent,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AuthorizationModule, { declarations: function () { return [AuthorizationComponent, LoginComponent, RegistrationComponent, ResetPasswordComponent, ChangePasswordComponent]; }, imports: function () { return [CommonModule,
        RouterModule,
        FormsModule,
        HttpClientModule,
        ReactiveFormsModule,
        RouterModule,
        ButtonModule,
        TextFieldModule,
        DropdownModule,
        CheckboxModule,
        ToastModule,
        DialogModule,
        SvgIconModule,
        LocalizationModule]; }, exports: function () { return [AuthorizationComponent, LoginComponent, RegistrationComponent, ResetPasswordComponent, ChangePasswordComponent]; } }); })();

class GuestGuard {
    constructor(router, authService) {
        this.router = router;
        this.authService = authService;
    }
    canActivate(route) {
        return this.authService
            .user$
            .pipe(take(1), map(user => !Boolean(user)), tap(canActivate => {
            if (!canActivate) {
                if (route.queryParams.backUrl) {
                    this.router.navigateByUrl(route.queryParams.backUrl).then().catch(() => {
                        this.router.navigateByUrl('/');
                    });
                }
                else {
                    this.router.navigateByUrl('/');
                }
            }
        }));
    }
}
GuestGuard.ɵfac = function GuestGuard_Factory(t) { return new (t || GuestGuard)(ɵngcc0.ɵɵinject(ɵngcc1.Router), ɵngcc0.ɵɵinject(AuthService)); };
GuestGuard.ɵprov = i0.ɵɵdefineInjectable({ factory: function GuestGuard_Factory() { return new GuestGuard(i0.ɵɵinject(i1$1.Router), i0.ɵɵinject(AuthService)); }, token: GuestGuard, providedIn: "root" });
GuestGuard.ctorParameters = () => [
    { type: Router },
    { type: AuthService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GuestGuard, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.Router }, { type: AuthService }]; }, null); })();

const ROUTES = [
    {
        path: '',
        component: AuthorizationComponent,
        canActivate: [GuestGuard],
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: ROUTE_LOGIN,
            },
            {
                path: ROUTE_LOGIN,
                component: LoginComponent,
            },
            {
                path: ROUTE_REGISTRATION,
                component: RegistrationComponent,
            },
            {
                path: ROUTE_RESET_PASSWORD,
                component: ResetPasswordComponent,
            },
            {
                path: ROUTE_CHANGE_PASSWORD,
                component: ChangePasswordComponent
            }
        ]
    }
];

class AuthorizationRoutingModule {
}
AuthorizationRoutingModule.ɵfac = function AuthorizationRoutingModule_Factory(t) { return new (t || AuthorizationRoutingModule)(); };
AuthorizationRoutingModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: AuthorizationRoutingModule });
AuthorizationRoutingModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [AuthorizationModule,
        RouterModule.forChild(ROUTES)] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AuthorizationRoutingModule, [{
        type: NgModule,
        args: [{
                imports: [
                    AuthorizationModule,
                    RouterModule.forChild(ROUTES)
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AuthorizationRoutingModule, { imports: [AuthorizationModule, ɵngcc1.RouterModule] }); })();

class AuthGuard {
    constructor(router, authService, configService) {
        this.router = router;
        this.authService = authService;
        this.configService = configService;
    }
    canActivate() {
        return this.authService
            .user$
            .pipe(take(1), map(user => !!user), tap(canActivate => {
            if (!canActivate) {
                this.router.navigate(['/', this.configService.get('authRoute'), ROUTE_LOGIN], { queryParams: { backUrl: window.location.pathname } });
            }
        }));
    }
}
AuthGuard.ɵfac = function AuthGuard_Factory(t) { return new (t || AuthGuard)(ɵngcc0.ɵɵinject(ɵngcc1.Router), ɵngcc0.ɵɵinject(AuthService), ɵngcc0.ɵɵinject(ɵngcc2.ConfigService)); };
AuthGuard.ɵprov = i0.ɵɵdefineInjectable({ factory: function AuthGuard_Factory() { return new AuthGuard(i0.ɵɵinject(i1$1.Router), i0.ɵɵinject(AuthService), i0.ɵɵinject(i2.ConfigService)); }, token: AuthGuard, providedIn: "root" });
AuthGuard.ctorParameters = () => [
    { type: Router },
    { type: AuthService },
    { type: ConfigService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AuthGuard, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.Router }, { type: AuthService }, { type: ɵngcc2.ConfigService }]; }, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { AuthApi, AuthGuard, AuthService, AuthorizationComponent, AuthorizationModule, AuthorizationRoutingModule, ChangePasswordComponent, FacebookService, GuestGuard, JwtAuthInterceptor, LoginComponent, ROUTE_CHANGE_PASSWORD, ROUTE_LOGIN, ROUTE_REGISTRATION, ROUTE_RESET_PASSWORD, RegistrationComponent, ResetPasswordComponent, VKService, ROUTES as ɵa };

